export const roundNumber = (value, decimals = 2) =>
  typeof value === "number"
    ? Math.round(value * 10 ** decimals) / 10 ** decimals
    : value;

const escapeCell = (value) => {
  if (value === null || value === undefined) return "";
  const str = String(value);
  return /[",\n]/.test(str) ? `"${str.replace(/"/g, '""')}"` : str;
};

const rowsToCsv = (rows, columns) => {
  const lines = [
    columns.map((column) => escapeCell(column.header)).join(","),
    ...rows.map((row) =>
      columns.map((column) => escapeCell(row[column.field])).join(",")
    ),
  ];

  return lines.join("\n");
};

export const downloadCsv = (filename, rows, columns) => {
  if (!rows?.length) return;

  const blob = new Blob([rowsToCsv(rows, columns)], {
    type: "text/csv;charset=utf-8;",
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
